import { parse } from 'query-string';

const shopId = parse(window.location.search).shopId;

// Enum of possible action types
export enum selecetedShopIdActionTypes {
  SELECTED_SHOP_ID_UPDATE = 'SELECTED_SHOP_ID_UPDATE',
}

export interface SelecetedShopIdReducerAction {
  type: selecetedShopIdActionTypes;
  payload: string;
}

export type SelecetedShopIdReducerState = string;

export const selecetedShopIdReducerInitialState: SelecetedShopIdReducerState =
  typeof shopId === 'string' ? shopId : '';

const selecetedShopIdReducer = (
  state: SelecetedShopIdReducerState,
  action: SelecetedShopIdReducerAction
): SelecetedShopIdReducerState => {
  switch (action.type) {
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default selecetedShopIdReducer;
